module.exports = __webpack_public_path__ + "static/pic01-0c0560c5c71f79f878968081502334a6.jpg";